import { createContext } from 'react';
import { useSensitivities } from 'hooks/useSensitivities';
import { SelectOption } from 'common/types/select-option.type';

export const SensitivitiesContext = createContext<{
  isLoading: boolean;
  sensitivities: any[];
  sensitivitiesOptions: SelectOption[];
  sensitivitiesOptionsWithoutNA: SelectOption[];
}>({
  isLoading: false,
  sensitivities: undefined,
  sensitivitiesOptions: [],
  sensitivitiesOptionsWithoutNA: [],
});

export const SensitivitiesProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const {
    isLoading,
    data: sensitivities,
    sensitivitiesOptions,
    sensitivitiesOptionsWithoutNA,
  } = useSensitivities();

  return (
    <SensitivitiesContext.Provider
      value={{
        isLoading,
        sensitivities,
        sensitivitiesOptions,
        sensitivitiesOptionsWithoutNA,
      }}
    >
      {children}
    </SensitivitiesContext.Provider>
  );
};
